import { memo } from "react";
import { jsx } from "react/jsx-runtime";
//#region src/icons/icon-24-logo-recraft-large.tsx
/**
* icon.24.logo.recraft.large
*
* ![](data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI2NCIgaGVpZ2h0PSI2NCIgZmlsbD0ibm9uZSIgdmlld0JveD0iMCAwIDI0IDI0Ij48cmVjdCB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIGZpbGw9IiMwMDAiIHJ4PSI0Ii8+PHBhdGggZmlsbD0iI2ZmZiIgZD0iTTEwLjY0MyAzYzMuNzg0IDAgNi44NTIgMi43NCA2Ljg1MiA2LjExN3YuMDAxYzAgMy4zNjUtMy4wNDYgNi4wOTctNi44MSA2LjExNmg2Ljk0NEwyMC4zMDMgMjBoLTYuOTc2bC0yLjY3Ni00Ljc2Ni0uMDA1LjAwMVYyMEgzLjY5N2wyLjQzMi04LjUwMWgyLjMyNmExNSAxNSAwIDAgMS0uMTg2LTIuMzgzYzAtMy4zNzcgMS4wNjMtNi4xMTUgMi4zNzQtNi4xMTZtMCAxLjEyQzkuOTU3IDQuMTIgOS40IDYuMzU4IDkuNCA5LjExNmMwIDIuNzYuNTU1IDQuOTk3IDEuMjQzIDQuOTk3LjY4NiAwIDEuMjQyLTIuMjM4IDEuMjQyLTQuOTk3UzExLjMzIDQuMTIgMTAuNjQzIDQuMTIiLz48L3N2Zz4=)
*
* https://staging.figma.com/file/ycDPAaAih2bZY5LgXehVai/?node-id=26838-12670
*/
const Icon24LogoRecraftLarge = memo(function Icon24LogoRecraftLarge(props) {
	return /* @__PURE__ */ jsx("svg", {
		width: "24",
		height: "24",
		fill: "none",
		viewBox: "0 0 24 24",
		...props,
		"data-fpl-icon-size": "24L",
		children: /* @__PURE__ */ jsx("path", {
			fill: "var(--fpl-icon-color, var(--color-icon))",
			d: "M10.643 3c3.784 0 6.852 2.74 6.852 6.117v.001c0 3.365-3.046 6.097-6.81 6.116h6.944L20.303 20h-6.976l-2.676-4.766-.005.001V20H3.697l2.432-8.501h2.326a15 15 0 0 1-.186-2.383c0-3.377 1.063-6.115 2.374-6.116m0 1.12C9.957 4.12 9.4 6.358 9.4 9.116c0 2.76.555 4.997 1.243 4.997.686 0 1.242-2.238 1.242-4.997S11.33 4.12 10.643 4.12"
		})
	});
});
//#endregion
export { Icon24LogoRecraftLarge };

//# sourceMappingURL=icon-24-logo-recraft-large.js.map